import type { CaptureResult } from 'posthog-js';
import posthog from 'posthog-js';

const SENSITIVE_PROPS = ['password', 'passwordConfirm', 'secret', 'email', 'phone', 'ssn'];

const beforeSend = (event: CaptureResult | null): CaptureResult | null => {
  if (!event) return null;
  const props = { ...event.properties };
  SENSITIVE_PROPS.forEach((k) => delete props[k]);
  return { ...event, properties: props };
};

export const posthogOptions = {
  api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
  defaults: '2026-01-30' as const,
  person_profiles: 'identified_only' as const,
  capture_pageview: false,
  autocapture: true,
  before_send: beforeSend,
};

export const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || '';

export default posthog;
